import { render, staticRenderFns } from "./OauthLogin.vue?vue&type=template&id=16573f47&scoped=true"
import script from "./OauthLogin.vue?vue&type=script&lang=js"
export * from "./OauthLogin.vue?vue&type=script&lang=js"
import style0 from "./OauthLogin.vue?vue&type=style&index=0&id=16573f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16573f47",
  null
  
)

export default component.exports